var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.12499 30.29112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .a {\r\n        fill: #81cbf1;\r\n      }\r\n\r\n      .b {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M667.99787,683.88453a57.49241,57.49241,0,0,1,8.646.213c3.533.338,3.826.922,9.772.912a11.36619,11.36619,0,0,0,4.188-1.054l52.519-21.598-3.086-7.639Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M697.627,678.72266a3.08489,3.08489,0,0,0,1.61035-.17578c.82422-.334,1.13086-.96485.877-1.59376-.23633-.584-.70508-.7832-1.67969-.76562-1.166.05078-2.00879-.22266-2.36523-1.10449a1.94148,1.94148,0,0,1,1.33593-2.5127,3.06747,3.06747,0,0,1,1.50391-.25195l.04394.74805a2.69952,2.69952,0,0,0-1.30566.18359c-.85351.34375-.97168.98438-.79883,1.41016.23535.584.73047.71875,1.72754.70312,1.22168-.01758,1.96387.27539,2.335,1.19141.38867.96386.0127,2.08593-1.46093,2.68164a3.4747,3.4747,0,0,1-1.75391.24512Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M700.96094,671.25391l1.05566,2.6123,3.02149-1.22168-1.05567-2.61133.81446-.33008,2.52343,6.2461-.81445.32812-1.18359-2.92773-3.02149,1.2207,1.1836,2.92871-.80567.3252-2.52344-6.2461Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M710.11328,674.82031l-1.07129-2.65039-3.42578-2.79687.917-.3711,1.57715,1.36817c.43164.375.76953.67968,1.14063,1.03613l.01855-.00781c.01172-.47754.06055-.97168.11035-1.541l.20215-2.08789.918-.37109-.64551,4.43359,1.07422,2.6582Z",
    transform: "translate(-667.99787 -654.71854)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShy);
export default __webpack_public_path__ + "static/media/Shy.e49f8e210f7887e9b4191cd58d31eeb3.svg";
export { ForwardRef as ReactComponent };